/**
 * Detalle de una ejecución de sincronización (009 · T029 · F6; contracts/ui.md §4). El sufijo `_`
 * la convierte en ruta hermana de `/integracion` (que no renderiza `<Outlet/>`), igual que
 * `marcadores_.$terminalId`.
 */
import { createFileRoute } from '@tanstack/react-router';

import { RunPage } from '../../features/integration/run-page';

export const Route = createFileRoute('/_app/integracion_/ejecuciones/$runId')({
  component: function IntegrationRunRoute() {
    const { runId } = Route.useParams();
    return <RunPage runId={runId} />;
  },
});
